"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  spareStockingManage: {
    common: {
      operationRequirement: '营运需求备件',
      spiManagement: '备件库存管理',
      approvalHistory: '审批历史'
    },
    btn: {
      cancel: '作废',
      refreshStock: '库存刷新'
    },
    placehoder: {
      selectDate: '选择日期'
    },
    keyWordFilter: {
      ir: '可查询备件名称、备件号、图纸号、设备名称、库位信息、定单号',
      iv: '可查询盘点单号、盘点人',
      po: '可查询处理单号、港口'
    },
    inventoryRecordManage: {
      refreshStockSuccess: '库存刷新成功',
      transferor: '调拨人',
      device: '设备',
      partsType: '备件类型',
      partsModel: '备件型号',
      proposedPriceCurrency: '参考价格单位',
      monitorFlag: '是否受控备件',
      blindFlag: '是否需要盲盘',
      partsRemark: '备注说明',
      stockQuantity: '实物库存数量',
      personInCharge: '保管人',
      isLtMinStock: '是否低于安全库存',
      isGtMaxStock: '是否高于最高库存',
      locationInfo: '库位信息',
      nowStockQyt: '现有库存',
      iRManage: '库存管理',
      stockQtyValue: '库存量',
      inRItem: '返修项目入库',
      changeStock: '移库',
      changeStockOptTips: '移库操作手册',
      hSPROHistory: '次品历史',
      sBLoction: '根据库位查找',
      shipName: '船名',
      dept: '部门',
      applyType: '设备名称',
      mtrCatory: '备件名称',
      mtrCatoryEn: '备件名称英文名',
      mtrName: '备件号',
      drawItem: '图纸号',
      drawItemIng: '在图号',
      mtrEnName: '规格型号',
      unit: '单位',
      stockNum: '库存',
      applySpec: '设备型号',
      eqpShop: '设备厂家',
      minStock: '安全库存',
      maxStock: '最高库存',
      option: '操作',
      outStock: '出入库',
      outStockMsg: '出入库信息',
      stockTip: '备件无法手动出库，仅能通过盘点或工单消耗',
      outStockNum: '实物库存数量',
      stockMsg: '库位信息',
      stockingNum: '实物库存数量',
      remark: '备注',
      outStockCatory: '出入库类型',
      number: '数量',
      date: '日期',
      checkedNum: '被替换物资数量',
      price: '单价',
      putLoc: '存放库位',
      hasHarm: '包含有害物质',
      outStockSeq: '出库顺序',
      inStock: '入库',
      inStockMsg: '入库信息',
      inStockCatory: '入库类型',
      outInStockDaily: '出入库记录',
      orderOrtransferNo: '定单号/调拨单号',
      currentLocation: '当前库存量',
      changeNum: '变化数量',
      currency: '币种',
      stockRate: '汇率',
      material: '备件',
      inOutDate: '出入库日期',
      inOrOut: '出库/入库',
      inOutStockCatory: '出入库类型',
      inOutFlag: '出入库标识',
      company: '公司',
      optiontor: '操作人',
      duties: '职务',
      beginDate: '起始时间',
      endDate: '结束时间',
      preQty: '期初库存',
      timeQty: '期间变化量',
      aftQty: '期末库存',
      columon: {
        shipCode: '船舶编码',
        locCode: '库位编码',
        locName: '库位名称(中文)',
        locNameEn: '库位名称(英文)'
      },
      rules: {
        typeRequired: '入库类型不能为空',
        numRequired: '数量不能为空',
        dateRequired: '日期不能为空',
        deptRequired: '部门不能为空',
        loctionRequired: '存放库位不能为空'
      }
    },
    inventoryVerification: {
      inventoryManual: '盘点操作手册',
      firstSubmitQty: '初次提交数量',
      onlyShowNoEq: '仅展示盘点数量不一致',
      onlyShowNoCheckItem: '仅展示未盘点项目',
      checkDeleteTip: '作废后本次盘点产生的库存记录将恢复至盘点之前，是否确认作废该记录',
      onlyShowControledItem: '仅展示受控项目',
      inventoryProfitReason: '盘盈盘亏原因',
      inventoryProfitExplain: '盘盈盘亏原因说明',
      monitorTip1: '受控项目盘盈盘亏需注明原因',
      monitorTip2: '受控项目盘盈盘亏不正常需注明原因说明',
      keyWordFilter: '可查询备件名称、备件编号',
      inventoryChecking: '库存盘点',
      inventoryInfo: '盘点信息',
      equipInfo: '设备信息',
      inventoryVerificationTips: '盘点单提交后，库存将自动进行调整，无需手动调整库存',
      prioritizeConsumption: '请优先消耗此类物品',
      spareInfo: '备件信息',
      inventoryFileList: '附件信息',
      inventoryHistoryList: '审批历史',
      icAdd: '库存盘点新增',
      icEdit: '库存盘点编辑',
      takingStock: '盘点中',
      approvaling: '审批中',
      approvalRej: '审批拒绝',
      approved: '审批通过',
      cancel: '已作废',
      allApproval: '全部',
      shipName: '船名',
      department: '部门',
      inventoryNo: '盘点单号',
      inventoryMan: '盘点人',
      inventoryTime: '盘点时间',
      status: '状态',
      remark: '备注',
      inventoryStartTime: '盘点发起时间',
      inventorySubmitTime: '盘点提交时间',
      sequenceCode: '顺序码',
      toEquip: '所属设备',
      spName: '备件名称',
      spNo: '备件号',
      drawingNo: '图纸号',
      inDrawingNo: '在图号',
      unit: '单位',
      currentLocation: '当前库位',
      lastStock: '上次存量',
      quantityReceived: '接收数量',
      consumptionQuantity: '消耗数量',
      bookStock: '账面存量',
      inventoryRecordTime: '账面存量统计时间',
      physicalStock: '实物存量',
      physicalStockTip: '实物存量请按照账面存量统计时间的存量填写',
      systemStockQtySum: '账面存量合计',
      checkStockQtySum: '实物存量合计',
      difference: '差值',
      gainOrloss: '盘盈/盘亏',
      gainOrlossNumber: '盘盈/盘亏数量',
      gainOrlossMoney: '盘盈/盘亏金额',
      company: '公司',
      equipName: '设备名称',
      equipCode: '设备编号',
      equipEsc: '设备型号',
      equipSeq: '设备序列号',
      manufacturer: '生产厂家',
      reCheck: '盘点复检',
      reCheck1: '以下盘点项与账面存量差距过大，请检查实物存量是否准确。若准确无误，请点击确定按钮提交；若有误，请点击取消按钮返回并驳回。',
      reCheck2: '以下盘点项与账面存量差距过大，请检查实物存量是否准确。若准确无误，请点击确定按钮提交；若有误，可在此弹窗中编辑并点击确定按钮提交。'
    },
    prosOrderMainManage: {
      prosOMag: '流向管理',
      spName: '船名',
      dept: '部门',
      opNo: '处理单号',
      opShop: '处理商',
      opTime: '处理时间',
      crgo: '港口',
      status: '状态',
      remark: '备注',
      option: '操作',
      opMsg: '处理信息',
      materialMsg: '备件信息',
      chooseDM: '选择处理备件',
      useType: '使用状态',
      hasHarm: '包含有害物质',
      currentLocation: '当前存放位置',
      applyType: '设备名称',
      mtrCatr: '设备型号',
      matrShop: '设备序列号',
      mtrName: '备件供应商',
      mtrNo: '备件名称',
      specNo: '备件号',
      drawItem: '图纸号',
      drawItemIng: '在图号',
      unit: '单位',
      opCatr: '处理类型',
      opNum: '处理数量',
      qty: '数量',
      badNum: '报废数量',
      backNum: '返修数量',
      allMtr: '全部',
      mtring: '在用备件',
      badMtr: '报废备件',
      noSubmit: '未提交',
      submited: '已提交',
      parts: '备件',
      rules: {
        spNameReq: '船名不能为空',
        deptReq: '部门不能为空',
        opNoReq: '处理单号不能为空',
        opTimeReq: '处理时间不能为空',
        opShopReq: '处理商不能为空'
      }
    }
  }
};